import { getConfigWithKeys } from '@cibo/core'

export type MAPBOX_CONFIG = 'MAPBOX_ACCESS_TOKEN' | 'MAPTILES_SERVICE_URL'

export const Config = getConfigWithKeys<MAPBOX_CONFIG>()
